import { request } from '../../../gateways/api'

export { updateMyList }

const updateMyList = async ({
  aanvraagID,
  method,
}: {
  aanvraagID: string
  method: 'add' | 'remove'
}): Promise<{ projecten: string[] }> => {
  const result = await request<{ projecten: string[] }>({
    url: `/rest/my-list`,
    method: method === 'remove' ? 'DELETE' : 'POST',
    data: { id: aanvraagID },
  })

  return result
}
